<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :hr="hr" />
    </div>
    <div class="content">
      <div class="promotion">
        <div class="container">
          <div class="section">
            <h2 class="section-heading">Promotions</h2>
            <routerLink to="/add-promotion">
              <button class="button">
                <font-awesome-icon icon="plus" class="icon" />&nbsp;Add Promotion
              </button>
            </routerLink>
          </div>
        </div>
        <div class="page-loader" v-show="pageLoading">
          <div>
            <PageLoader />
          </div>
        </div>
        <div class="promotion__body" v-show="!pageLoading">
          <div class="promotion__div--content-body-enrol">
            <p>You can view all company wide promotions here:</p>

            <div>
              <div class="error" v-show="dataFetchError">
                <p>Unable to fetch promotions. Please try again.</p>
              </div>
            </div>

            <div
              class="alert d-flex align-items-center"
              role="alert"
              v-if="noData"
            >
              <font-awesome-icon icon="times-circle" />
              <p>There are no promotions created yet.</p>
            </div>

            <div class="promotion__div--content-body-enrol-table">
              <div class="promotion__div--content-body-table-header">
                <div>Name</div>
                <div>Promoted From</div>
                <div>Promoted To</div>
                <div>Promotion Date</div>
              </div>
              <div class="promotion__div--content-body-table-body">
                <div v-for="(promotion, index) in promotions" :key="index">
                  <div>
                    {{ promotion.employee.user.firstname }}
                    {{ promotion.employee.user.lastname }}
                  </div>
                  <div v-if="promotion.present_designation !== null">
                    {{ promotion.present_designation.name }}
                  </div>
                  <div v-if="promotion.present_designation === null"></div>
                  <div v-if="promotion.new_designation !== null">
                    {{ promotion.new_designation.name }}
                  </div>
                  <div v-if="promotion.new_designation === null"></div>
                  <div></div>
                  <div>{{ promotionDate(promotion) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";

export default {
  name: "Promotion",
  components: {
    Header,
    Sidebar,
    PageLoader,
  },
  data() {
    return {
      item: "promotion",
      hr: "hr",

      promotions: [],

      pageLoading: true,
      dataFetchError: false,
      noData: false,
    };
  },
  metaInfo: {
    title: ' Core HR Solutions - Centralized Human Resources Management',
    meta: [
      { name: 'description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { property: 'og:title', content: 'Core HR Solutions - Centralized Human Resources Management' },
      { property: 'og:description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/promotion' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: ' Core HR Solutions - Centralized Human Resources Management' },
      { name: 'twitter:description', content: 'Simplify your HR processes with HR Desk\'s Core HR solutions. Centralize employee data, automate administrative tasks, and improve HR efficiency.' },
      { name: 'twitter:image:alt', content: ' core HR, HR solutions, employee data management, HR automation, HR efficiency' },
    ]
  },
  created() {
    this.getPromotions();
  },

  methods: {
    getPromotions(url = types.GET_PROMOTION_API) {
      this.$http
        .get(url)
        .then((resp) => {
          this.promotions = resp.data.data.data;
          this.pageLoading = false;
          if (this.promotions.length) {
            return;
          }
          this.noData = true;
        })
        .catch((err) => {
          this.pageLoading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    promotionDate(promotion) {
      if (!promotion) return;
      const date = new Date(promotion.created_at);
      const dateString = date.toLocaleString().split(", ");
      return dateString[0];
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

   .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
   margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.promotion {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: left;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
    p {
      margin: 0;
      padding-bottom: 10px;
    }
    p::first-letter {
      text-transform: uppercase;
    }
  }

  .page-loader {
    margin-top: 100px;

    > div {
      width: 55px;
      margin: auto;
    }
  }

  .alert {
    padding-top: 10px;
    padding-bottom: 30px;
    font-size: 1rem;
    svg {
      margin-right: 7px;
    }
    p {
      margin-bottom: 0;
    }
  }

  .promotion__header {
    overflow: hidden;
    padding-bottom: 5px;

    > .promotion__header--text {
      width: 200px;
      float: left;
      font-size: 2.083rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .promotion__header--btn {
      float: right;
      width: 20rem;

      > div {
        width: 9.063rem;
        height: 38px;
        border-radius: 2px;
        background-color: #5099de;
        float: right;
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: left;

        > a {
          color: #ffffff;
          text-decoration: none;
          > div {
            height: 38px;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }
      }
    }
  }

  > .promotion__body {
    border-top: 1px solid #caced5;
    padding: 50px 5px 0 5px;

    > .promotion__div--content-body-enrol {
      margin-bottom: 50px;
      > p {
        font-size: 1.458rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-bottom: 50px;
      }

      .promotion__div--content-body-enrol-filter {
        overflow: hidden;
        > .promotion__div--content-body-filter-left {
          width: 120px;
          height: 35px;
          border-radius: 2px;
          border: solid 1px #caced5;
          background-color: #ffffff;
          float: left;
          margin-right: 20px;
          font-size: 0.833rem;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.19;
          letter-spacing: normal;
          text-align: left;
          color: #777777;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }

        > .promotion__div--content-body-filter-right {
          width: 200px;
          height: 35px;
          border-radius: 2px;
          background-color: #ffffff;
          float: left;
        }
      }

      > .promotion__div--content-body-enrol-table {
        margin-top: 30px;
        > .promotion__div--content-body-table-header {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > div {
            width: 25%;
            text-align: center;
            font-size: 1.042rem;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1;
            letter-spacing: normal;
            color: #000000;
            @media (max-width: 768px) {
              font-size: 0.8rem;
            }
          }
        }

        .promotion__div--content-body-table-body {
          border-top: 5px solid #5099de;
          margin-top: 20px;

          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            height: 50px;
            margin-bottom: 20px;
            background-color: #ffffff;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

            > div {
              width: 20%;
              text-align: center;
              font-size: 1.042rem;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #777777;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;

              > div {
                width: 4.948vw;
                height: 38px;
                border-radius: 2px;
                border: solid 1px #5099de;
                font-size: 0.625rem;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.67;
                letter-spacing: normal;
                text-align: center;
                margin: auto;
                cursor: pointer;
                overflow: hidden;

                > a {
                  text-decoration: none;
                  color: #000;
                  > div {
                    height: 38px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: center;
                    justify-content: center;
                    align-content: center;
                  }
                }
              }
            }
          }
        }
      }
    }

    > .promotion__div--content-body-paginate {
      border: 1px solid red;
      width: 20.833vw;
      margin: auto;
      height: 40px;
      border-radius: 4px;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
      border: solid 1px #d7dae2;
      background-color: #ffffff;
      margin-bottom: 150px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;

      > .promotion__div--content-body-paginate-prev {
        width: 20%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #5099de;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }

      > .promotion__div--content-body-paginate-page {
        width: 60%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 40px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;

        > div {
          width: 20%;
          height: 40px;
          border: solid 1px #d7dae2;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }

      > .promotion__div--content-body-paginate-next {
        width: 20%;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: center;
        color: #000;
        height: 52px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        cursor: pointer;
      }
    }
  }
}
.container {
  display: flex;
  // flex-direction: column;
  align-items: stretch;
}

.section {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.section-heading {
  font-size: 1.5rem;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #5099de;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 70%;
  .icon {
    margin-right: 0.25rem;
  }
}

.button:hover {
  background-color: #0056b3;
}

@media (min-width: 768px) {
  .container {
    flex-direction: row;
    align-items: center;
  }

  .section {
    flex: 1;
    margin-right: 20px;
  }

  .section-heading {
    margin-bottom: 0; 
  }

  .button {
    flex-shrink: 0; 
    margin-top: 10px; 
  }
}
</style>
